"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalTitle = void 0;
function ModalTitle(props) {
    return <span className="text-center text-xl font-mono font-bold">{props.children}</span>;
}
exports.ModalTitle = ModalTitle;
